module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074e6_banner_800x600.e62e350c.png";